import Images from '@assets/images';
import { Accordion, Button, Typography } from '@components/base';
import { Avatar, DocumentRow } from '@components/common';
import { DOCUMENT_GENERATION_STATUS, TRANSPORTATION_MODE_ENUM } from '@helpers/constants';
import { AppContext } from '@helpers/hooks/AppContext';
import { ITaskTabProps } from '@helpers/types/task-tabs';
import { getFormattedDate } from '@helpers/utils';
import moment from 'moment';
import { useContext, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Footer from '../components/footer';
import css from './index.module.scss';
import { Link } from 'react-router-dom';

interface IPackingListCard {
  taskData: Partial<ITaskTabProps>;
}

const ALWAYS_ELIGIBLE = [
  TRANSPORTATION_MODE_ENUM.AIR,
  TRANSPORTATION_MODE_ENUM.RAIL,
  TRANSPORTATION_MODE_ENUM.ROAD
];

const GeneratePostPackingList = (props: IPackingListCard) => {
  const navigate = useNavigate();
  const params = useParams();
  const { appDispatch } = useContext(AppContext);
  const { taskData } = props;
  const taskItem = taskData;
  /**
   * Used for for doc generation status and render UI accordingly
   */
  const docGenerationStatus = useMemo(() => {
    if (taskItem?.post_shipment_packaging_generation_status as any) {
      return DOCUMENT_GENERATION_STATUS.find(
        (i) => i.value === taskItem?.post_shipment_packaging_generation_status
      )?.label;
    }
    return null;
  }, [taskItem]);

  const shouldEnableGeneration = useMemo(() => {
    if (!taskData) return false;

    const { transportation_mode, is_container_details_added } = taskData;

    const isAlwaysEligible = ALWAYS_ELIGIBLE.includes(transportation_mode ?? '');
    const isSeaAndReady =
      transportation_mode === TRANSPORTATION_MODE_ENUM.SEA && Boolean(is_container_details_added);

    return isAlwaysEligible || isSeaAndReady;
  }, [taskData?.transportation_mode, taskData?.is_container_details_added]);

  return (
    <div className={css.mainWrapper}>
      <Accordion defaultExpanded>
        <Accordion.Header className={css.accordionHeader}>
          <div className={css.header}>
            <div className={css.wrapper}>
              {!taskItem?.is_completed ? (
                <Avatar src={Images.illustrationEdit} alt="" />
              ) : (
                <Avatar src={Images.alertSuccessFaint} alt="" />
              )}

              <Link to={`/order/${taskItem?.order}`} style={{ textDecoration: 'none' }}>
                <Typography variant="h5" className={css.underlineOnHover}>
                  #{taskItem?.readable_task_id} - Generate Post-Shipment Packing List
                </Typography>
              </Link>
            </div>
            <div className={css.pocWrapper}>
              {!taskItem?.is_completed && !docGenerationStatus && (
                <Button
                  variant="text"
                  disabled={!shouldEnableGeneration}
                  onClick={() => {
                    appDispatch({
                      type: 'setPIData',
                      payload: {
                        task_id: taskItem?.task_id,
                        order_id: taskItem?.order,
                        invoiceType: 'post_shipment'
                      }
                    });
                    navigate(
                      `/order/generate-packing-list/${
                        (params.id as string) ?? (taskItem?.order as string)
                      }`
                    );
                  }}
                  className={css.assignButton}
                >
                  {shouldEnableGeneration ? `Generate` : `Add Container Details`}
                </Button>
              )}
              {!taskItem?.is_completed &&
                (docGenerationStatus == 'DOC_GENERATION_PROCESSING' ||
                  docGenerationStatus == 'DOC_GENERATION_REQUESTED') && (
                  <Button variant="text" disabled className={css.assignButton}>
                    Document generation in process
                  </Button>
                )}
              {!taskItem?.is_completed && docGenerationStatus == 'DOC_GENERATION_FAILED' && (
                <Button variant="text" disabled className={css.assignButton}>
                  Document Generation Failed
                </Button>
              )}
            </div>
          </div>
        </Accordion.Header>
      </Accordion>
      <Footer
        createdDate={props.taskData.created_at as Date}
        updatedDate={props.taskData.updated_at as Date}
      />
    </div>
  );
};

export default GeneratePostPackingList;
